module.exports = __webpack_public_path__ + "img/card-el-2.d83437cd.svg";